export class DialogMode
{
	static SEARCHING: string = 'SEARCHING';
	static SHOW_PRODUCT_ITEM: string = 'SHOW_PRODUCT_ITEM';
	static SHOW_RECENT: string = 'SHOW_RECENT';
}
